// DEPENDENCIES ---------------------------------------------------------------- //

// import React from 'react';

import { Scenarios } from '@gql/base-types';

import TileGroup from '@components/Timeline/Tile/TileGroup';

import ScheduleMoveStatusBadge from '@features/schedule/components/ScheduleMoveStatusBadge';

// TYPES ---------------------------------------------------------------- //

export interface ScenarioTileProps {
  scenario: Scenarios;
  endGapWidth?: number;
  isSelected?: boolean;
  isSelectedOverlayColor?: string;
  isSelectedOverlayIconColor?: string;
  onClick?: () => void;
  size?: 'compressed' | 'small' | 'medium' | 'large';
  startGapWidth?: number;
  zIndex?: number;
  zoom?: number;
}

// COMPONENT ---------------------------------------------------------------- //

const ScenarioTile = ({
  scenario,
  endGapWidth = 0,
  isSelected = false,
  isSelectedOverlayColor = '#404860',
  isSelectedOverlayIconColor = '#ffffff',
  onClick,
  size = 'medium',
  startGapWidth = 0,
  zIndex = 0,
  zoom = 4,
}: ScenarioTileProps) => {
  const moveLinks = scenario?.moves;

  return (
    <TileGroup
      endGapWidth={endGapWidth}
      isSelected={isSelected}
      isSelectedOverlayColor={isSelectedOverlayColor}
      isSelectedOverlayIconColor={isSelectedOverlayIconColor}
      onClick={onClick}
      startGapWidth={startGapWidth}
      zIndex={zIndex}
      zoom={zoom}
    >
      {moveLinks?.map(moveLink => (
        <ScheduleMoveStatusBadge
          key={moveLink?.move?.id}
          move={moveLink?.move}
          identifier={`#${moveLink?.move?.id}`}
          size={size}
          zIndex={zIndex}
          zoom={zoom}
        />
      ))}
    </TileGroup>
  );
};

// EXPORT ---------------------------------------------------------------- //

export default ScenarioTile;
